import { TextField } from '@mui/material'
import intl from 'localization/components'

interface EmailProps {
  messages: Record<string, string>
  props: {
    value?: string
    onChange: (value: string) => void
  }
}

const Email = ({ messages, props }: EmailProps) => {
  const { value, onChange } = props

  return (
    <TextField
      size="small"
      style={{ width: '100%' }}
      value={value}
      label={messages[intl.companyInfo('email')]}
      onChange={(event) => {
        return onChange(event.target.value)
      }}
    />
  )
}

export default Email
